import Vue from 'vue';
import Main from './main.vue';

const PayConstructor = Vue.extend(Main);

function Promt(opts = {}) {
  const instance = new PayConstructor({
    data: opts,
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.show(opts);
  return instance;
}

export default Promt;
